import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { applyTabIcon } from './tabIcon';

applyTabIcon();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    {/* Pass oidcConfig as the 'authConfig' prop */}
      <App />
  </BrowserRouter>
);
